import React, { useState, useEffect, useCallback } from 'react'
import CustomerList from '../CustomerList'
import formatMoney from '../../../util/formatMoney'
import * as S from './styles'
import Gallery from '../Gallery'
import Faq from '../../Faq'
import Breadcrumb from '../../Breadcrumb'
import IncrementStepper from '../../IncrementStepper'
import Select from '../../Select'
import { useAuth } from '../../../context/AuthContext'
import api from '../../../services/api'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import LoadingBackground from '../../LoadingBackground'
import { useCart } from '../../../context/CartContext'
import GradeSelector from '../../GradeSelector'
import CustomGroups from '../../CustomGroups'
import { IMAGE_URL } from '../../../constants'
import { loadEndpointWithPagination } from '../../../util/loadEndpointWithPagination'

function DetailProduct ({ product, addProduct }) {
  const [qty, setQty] = useState(0)
  const [grade, setGrade] = useState([])
  const [gradeValue, setGradeValue] = useState()
  const [structure, setStructure] = useState([])
  const [geralCharacteristics, setGeralCharacteristics] = useState({})
  const [customerCharacteristics, setCustomerCharacteristics] = useState([])
  const { verifyAcessWithoutLogin, authenticated } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const breadcrumbParent = location.state?.breadcrumbParent

  const handleBreadcrumbBack = () => {
    if (breadcrumbParent?.origin === 'home-highlights') {
      navigate('/', { state: { scrollTo: 'destaques' } })
    } else {
      navigate(-1)
    }
  }
  const storedCustomer = JSON.parse(localStorage.getItem('DAuth:customer'));
  const customerInfo = JSON.parse(localStorage.getItem('customerInfo'));
  const showProductPromotionInPortal = storedCustomer?.environmentConfiguration?.showProductPromotionInPortal
  const showProductWarehouseQuantity = storedCustomer?.environmentConfiguration?.showProductWarehouse
  const [allCharacteristicsList, setAllCharacteristicsList] = useState()
  const [productCharacteristicsList, setProductCharacteristicsList] = useState()
  const [unitMeasureList, setUnitMeasureList] = useState()
  const [characteristicValues, setCharacteristicValues] = useState()
  const [isInStructureValues, setIsInStructureValues] = useState()
  const [productWarehouseQuantity, setProductWarehouseQuantity] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const findSkuProduct = grade.find(item => item.id === gradeValue)
  const skuProductPrice = findSkuProduct && findSkuProduct?.price > 0 ? findSkuProduct.price : null
  const productImg = findSkuProduct?.images && findSkuProduct?.images.length > 0 ? findSkuProduct.images : product.images
  const accessWithoutLogin = verifyAcessWithoutLogin()
  const { cart } = useCart()
  const findProductOnCart = cart?.items?.find(item => item.productId === product.id)
  const formatedCharacteristics = Object.entries(geralCharacteristics).reduce((memo, [key, value]) => {
    memo = `${memo}${key}: ${value}<br>`
    return memo
  }, '')

  const formatProducts = (products) => {
    return Object.entries(products).map(([productId, product]) => {
      const descriptions = product.map(item => `${item.quantity} ${item.description}`)
      const lastDescription = descriptions.pop()
      product.description = `${descriptions.join(', ')} e ${lastDescription}.`
      product.productId = productId
      product.thumbnail = product[0].thumbnail ?? '/logo.png'
      product.productName = product[0].productName
      product.productPrice = product[0].productPrice
      if (product[0].thumbnail && product[0].thumbnail.length > 0) {
        if (product[0].thumbnail.includes('http')) { product.thumbnail = product[0].thumbnail } else { product.thumbnail = `${IMAGE_URL}${product[0].thumbnail}` }
      } else {
        product.thumbnail = '/logo.png'
      }

      return product
    })
  }

  const verifyOriginalPrice = () => {
    if ( grade.length > 0 && skuProductPrice ) {
      return product.originalPrice > skuProductPrice
    } else {
      return product.originalPrice > product.price
    }
  }

  const getCharacteristics = useCallback(async () => {
    let data = allCharacteristicsList?.map(element => {
      const matchedItem = productCharacteristicsList?.find(item => item.characteristicId === element.id);
      if (matchedItem) {
        return {
          ...matchedItem,
          description: element.description,
          unitMeasure: element.unitMeasure
        }
      };
      return null; // Retorna null se não houver correspondência
    }).filter(item => item !== null);

    if (data.length > 0) {
      let tmpGeralCharacteristics = {};
      let tmpAllCharacteristicsValues = [];
      for (const item of data) {
        const unit = unitMeasureList?.find((elem) => elem.value === item.unitMeasure);
        if (item.value) {
          tmpGeralCharacteristics[item.description] = `${item.value}${unit ? unit.shortDescription : ''}`;
        } else {
          try {
            const response = await loadEndpointWithPagination(`/api/v2/Characteristic/${item.characteristicId}/Values`, 100);
            const allValuesResponses = response?.flat() || [];
            tmpAllCharacteristicsValues.push({
              charId: item.characteristicId,
              response: allValuesResponses,
            });
            const nullCharacteristic = allValuesResponses?.find(chara => chara.id === item.valueId);
            tmpGeralCharacteristics[item.description || ''] = `${nullCharacteristic?.description || ''}${unit ? unit.shortDescription : ''}`;
          } catch (error) {
            console.error('Erro ao buscar a característica nula:', error);
          }
        }
      }
      setGeralCharacteristics(prev => ({ ...prev, ...tmpGeralCharacteristics }));
      setCharacteristicValues(tmpAllCharacteristicsValues);
    }
  }, [allCharacteristicsList, productCharacteristicsList, unitMeasureList]);

  const getGroupedProducts = (products) => {
    const groupedProducts = products.reduce((memo, product) => {
      if (!memo[product.productId]) {
        memo[product.productId] = [];
      }
      memo[product.productId].push(product);
      return memo;
    }, {});

    return groupedProducts;
  }

  useEffect(() => {
    const getData = async () => {
      try {
        setGeralCharacteristics({})
        setUnitMeasureList([]);
        setAllCharacteristicsList([]);
        setProductCharacteristicsList([]);
        const [responseAllChars, responseProductChars, responseUnitMeasure, responseGrade, responseStructure, responseIsInStructure] = await Promise.all([
          api.get('/api/v2/Characteristic'),
          api.get(`/api/v2/Product/${product.id}/Characteristics`),
          api.get('/Domain?DomainId=UNIDADE_MEDIDA'),
          api.get(`/api/v2/Product/${product.id}/Sku?HideZeroPriced=true`),
          api.get(`/api/v2/Product/${product.id}/Structure`),
          api.get(`/api/v2/Product/${product.id}/Structure?isInStructure=true`)
        ]);

        setCustomerCharacteristics(storedCustomer?.environmentConfiguration.characteristicsB2B)
        setAllCharacteristicsList(responseAllChars.data.response.data);
        setProductCharacteristicsList(responseProductChars.data.response.data);
        setUnitMeasureList(responseUnitMeasure.data);
        setGrade(responseGrade.data.response.data)
        setStructure(responseStructure.data.response.data)
        setIsInStructureValues(responseIsInStructure.data.response.data)
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      } finally {
        setIsLoading(false);
      }
    }

    getData()
  }, [product.id])

  useEffect(() => {
    const loadCharacteristics = async () => {
      setIsLoading(true);
      await getCharacteristics();
      setIsLoading(false);
    }

    if (productCharacteristicsList && unitMeasureList && customerCharacteristics) {
      loadCharacteristics();
    }
  }, [productCharacteristicsList, unitMeasureList, customerCharacteristics])

  useEffect(() => {
    if (!findProductOnCart?.productSkuDataId) {
      const initialQty = findProductOnCart && findProductOnCart?.quantity > 0 ? findProductOnCart?.quantity : 0;
      setQty(initialQty)
    }

    if (showProductWarehouseQuantity) {
      setProductWarehouseQuantity(findSkuProduct ? findSkuProduct?.warehouseAvailableQuantity : product.warehouseQuantity)
    } else {
      setProductWarehouseQuantity(null)
    };
  }, [product.id, gradeValue, findProductOnCart])

  return (
    <>
      {isLoading ? (
        <LoadingBackground />
      ) : (
        <S.Product>
          {product.description && (
            <Breadcrumb
              current={product.description}
              parent={breadcrumbParent?.label || 'Categorias de Produtos'}
              parentOnClick={breadcrumbParent ? handleBreadcrumbBack : undefined}
            />
          )}
          <S.ProductWrapper>
            <S.ProductDetailMobile>
              <S.ProductCode>Cód.: #{product.customerCode.length > 0 ? product.customerCode : product.productId}</S.ProductCode>
              <S.ProductTitle>
                {product.description}
                {product.multiplicationFactor > 1 ? <S.ProductSubTitle>(x{product.multiplicationFactor})</S.ProductSubTitle> : <></>}
              </S.ProductTitle>
              <CustomerList 
                productId={product.id}
                productWarehouseQuantity={productWarehouseQuantity}
                isDetailProductPage={true}
                characteristicValues={characteristicValues}
                unitMeasure={unitMeasureList}
                allCharacteristicsList={allCharacteristicsList}
                productCharacteristicsList={productCharacteristicsList}/>
            </S.ProductDetailMobile>
            <S.ProductGallery>
              <Gallery images={productImg || []} />
            </S.ProductGallery>
            <S.ProductContent>
              <S.ProductDetailDesk>
                <S.ProductCode>Cód.: #{product.customerCode.length > 0 ? product.customerCode : product.productId}</S.ProductCode>
                <S.ProductTitle>
                  {product.description}
                  {product.multiplicationFactor > 1 ? <S.ProductSubTitle>(x{product.multiplicationFactor})</S.ProductSubTitle> : <></>}
                </S.ProductTitle>
                {structure.length > 0 &&
                  structure.map((item) => {
                  return (
                    <S.ProductKitContentLabel>{item.quantity}x {item.description}</S.ProductKitContentLabel>
                  )
                  })}
                <CustomerList 
                  productId={product.id}
                  productWarehouseQuantity={productWarehouseQuantity}
                  isDetailProductPage={true} 
                  characteristicValues={characteristicValues}
                  unitMeasure={unitMeasureList}
                  allCharacteristicsList={allCharacteristicsList}
                  productCharacteristicsList={productCharacteristicsList}
                />
              </S.ProductDetailDesk>

              <S.ProductCartContainer>
                {
                  accessWithoutLogin === false ?
                    showProductPromotionInPortal && verifyOriginalPrice() ? 
                      <>
                        <S.ProductPrices>
                          <S.ProductOriginalPrice>R$ {formatMoney(product.originalPrice, false)}</S.ProductOriginalPrice>
                          <S.ProductPriceContainer>
                            <S.ProductPriceLabel>R$</S.ProductPriceLabel>
                            <S.ProductPrice>{grade.length > 0 && skuProductPrice ? formatMoney(skuProductPrice, false) : formatMoney(product.price, false)}</S.ProductPrice>
                          </S.ProductPriceContainer>
                        </S.ProductPrices>
                      </>
                    : 
                    <S.ProductPrices>
                      {/* <S.ProductPriceReduce>De <span>{product.price}</span> por</S.ProductPriceReduce> */}
                      <S.ProductPriceContainer>
                        <S.ProductPriceLabel>R$</S.ProductPriceLabel>
                        <S.ProductPrice>{grade.length > 0 && skuProductPrice ? formatMoney(skuProductPrice, false) : formatMoney(product.price, false)}</S.ProductPrice>
                        {/* <S.ProductPriceDiscount>-30%</S.ProductPriceDiscount> */}
                      </S.ProductPriceContainer>
                    </S.ProductPrices>
                  : null
                }
                {(!!authenticated || !customerInfo.b2BSellingInfoDisabled) &&
                  <S.ProductCartInfos style={{marginLeft: 'auto'}}>
                    {
                      grade.length === 0 && 
                        <S.ProductCartField>
                          <S.ProductCartFieldLabel>Qtde:</S.ProductCartFieldLabel>
                          <S.ProductCartFieldWrapper>
                            <IncrementStepper qty={qty} setQty={setQty} />
                          </S.ProductCartFieldWrapper>
                        </S.ProductCartField>
                    }
                    {
                      accessWithoutLogin === true ? (
                        <Link to='/login'>
                          <S.ProductButton>
                            Ver preço
                          </S.ProductButton>
                        </Link>
                      ) : (
                        grade.length === 0 &&
                        <S.ProductButton
                          onClick={() => addProduct(product.id, (qty > 0 ? qty : 1), gradeValue)}
                          disabled={!!((product.stockRestrition && product.warehouseQuantity <= 0) || (grade.length > 0 && !gradeValue))}
                        >
                          {product.stockRestrition && product.warehouseQuantity <= 0 ? 'Produto sem estoque' : 'Comprar'}
                        </S.ProductButton>
                      )
                    }
                    {
                      grade.length > 0 && product.stockRestrition && product.warehouseQuantity <= 0 &&
                      <S.ProductButton disabled>
                        Produto sem estoque
                      </S.ProductButton>
                    }
                  </S.ProductCartInfos>
                }
              </S.ProductCartContainer>
              {!!authenticated && grade.length > 0 && (!product.stockRestrition || (product.stockRestrition && product.warehouseQuantity > 0)) && (
                <GradeSelector grade={grade} cart={cart} productId={product.id} selectedGrade={gradeValue} onSelectGrade={setGradeValue}/>
              )}
              {(product.additionalInformation && product.additionalInformation != '<p><br></p><p></p>') && (
                <S.ProductDescriptionContainer>
                  <S.ProductDescription className="ql-editor" dangerouslySetInnerHTML={{ __html: product.additionalInformation }} />
                </S.ProductDescriptionContainer>
              )}
              {formatedCharacteristics.length > 0 && (
                <Faq productDetails title='Características Gerais' content={formatedCharacteristics} />
              )}
              <CustomGroups entity={2} entityId={product.id} disabled={true} />
              {
                isInStructureValues?.length > 0 && (
                  <S.ProductDescriptionContainer>
                    <S.ProductStructureTitle>Este <span>produto</span> aparece em:</S.ProductStructureTitle>
                    {/* em links com um external icon no começo */}
                    {formatProducts(getGroupedProducts(isInStructureValues))
                    .map((product, index) => (
                      <S.ProductStructureSubItem key={index}>
                        <S.ProductStructureSubItemContent>
                          <S.ProductThumbnail src={product.thumbnail} alt={product.productName} />
                          <S.ProductStructureInfo>
                          <S.ProductStructureName>{product.productName || "Sem nome"}</S.ProductStructureName>
                          <S.ProductStructureDescription>Contém: {product.description}</S.ProductStructureDescription>
                          <Link to={`/product/${product.productId}`}>
                            <S.ProductStructureButton>
                              Visualizar
                            </S.ProductStructureButton>
                          </Link>
                          </S.ProductStructureInfo>
                        </S.ProductStructureSubItemContent>
                      </S.ProductStructureSubItem>
                    ))
                    }
                  </S.ProductDescriptionContainer>
                )
              }
            </S.ProductContent>
          </S.ProductWrapper>
        </S.Product>
      )}
    </>
  )
}

export default DetailProduct
